import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/InfoBlock.module.scss';

import News from './News';
import Tabs from '../Common/Tabs';

const InfoBlock: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState('benefits');

  const newsTabs = [
    {
      label: t('common:news.benefitsTab'),
      key: 'benefits',
    },
    {
      label: t('common:news.newsTab'),
      key: 'news',
    },
    {
      label: t('common:news.articlesTab'),
      key: 'articles',
    },
  ];

  return (
    <div className={styles.wrapper}>
      <Tabs tabs={newsTabs} active={{ activeTab, setActiveTab }} />
      <div aria-live="polite" aria-atomic="true" aria-relevant="all">
        {activeTab === 'news' && <News teaser={true} />}
        {activeTab === 'benefits' && <News benefits={true} teaser={true} />}
        {activeTab === 'articles' && <News articles={true} teaser={true} />}
      </div>
    </div>
  );
};

export default InfoBlock;
